// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent_card {
  background-color: #f2f2f2;
  font-size: 12px;
}

.agent_feild {
  float: left;
  width: 100%;
}

.vendot_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.vendor_type {
  width: 100%;
  height: 30px;
  position: relative;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.text_style {
  font-size: 12px !important;
  color: black;
}

.vendor_text {
  color: black;
  display: inline-block;
  top: 7px;
  font-weight: 600;
  font-size: 15px !important;
  text-transform: uppercase;
}

.vendor_auto_feild {
  width: 100%;
  position: relative;
  top: 0%;
}

.text-ellipsis {
  max-width: 93%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action_btn {
  width: 42px;
  height: 42px;
  line-height: 32px;
  background-color: #1590a2;
  color: white;
  font-size: 17px;
}

.vendar_card {
  width: 20%;
  min-height: 260px;
}

.vendar_card_min {
  width: 33%;
  min-height: 260px;
}

.download_files {
  padding-inline: 2%;
  margin-right: 3%;
  border: 1px solid darkgray;
  border-radius: 18px;
  padding-block: 2px;
  font-size: 11px !important;
}
.download_files i {
  color: #3f9fe3;
}

.download_files:hover {
  background-color: #3f9fe3;
  color: white;
  border: navajowhite;
}
.download_files:hover i {
  color: white;
}

.vendor_redirect {
  padding: 2%;
  border-radius: 5%;
  background-color: #ebebeb;
  display: flex;
  align-items: center;
}
.vendor_redirect .redirect_icon {
  font-size: 14px;
  color: grey;
}

.vendor_redirect:first-child {
  border-right: 1px solid #b9b8b8;
}

.vendor_redirect:hover {
  background-color: #1590a2;
  color: white;
}
.vendor_redirect:hover .redirect_icon {
  font-size: 14px;
  color: white;
}

.vendor_form_field {
  width: 100%;
}

.vendor_form_field input {
  font-size: 12px !important;
}

::ng-deep.vendor_form_field .mat-form-field-infix {
  padding: 0% !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

::ng-deep.vendor_form_field .mat-form-field-empty.mat-form-field-label {
  display: block;
  position: relative !important;
  top: 7px !important;
}

::ng-deep.vendor_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.59375em) scale(0.75);
  width: 133.33333%;
  position: relative;
  top: 13px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/vendor/contact/contact.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA;EAA0B,eAAA;AAA9B;;AAEI;EACI,WAAA;EACA,WAAA;AACR;;AACM;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAER;;AAAM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAGR;;AAAM;EACE,sBAAA;AAGR;;AAAM;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAGR;;AADM;EACI,0BC/BC;EDgCD,YAAA;AAIV;;AAFM;EACE,YAAA;EACE,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;AAKV;;AAHM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;AAMR;;AAJM;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAOR;;AAJI;EACJ,WAAA;EAAY,YAAA;EAAa,iBAAA;EAAkB,yBAAA;EAA0B,YAAA;EAAa,eAAA;AAYlF;;AAVA;EACE,UAAA;EAAW,iBAAA;AAcb;;AAZA;EACE,UAAA;EAAW,iBAAA;AAgBb;;AAbA;EACE,kBAAA;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;AAgBJ;AAfI;EACE,cAAA;AAiBN;;AAdA;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;AAiBF;AAhBE;EACE,YAAA;AAkBJ;;AAdA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAiBF;AAhBE;EACE,eAAA;EACA,WAAA;AAkBJ;;AAfA;EACA,+BAAA;AAkBA;;AAhBA;EACE,yBAAA;EACA,YAAA;AAmBF;AAlBE;EACE,eAAA;EACA,YAAA;AAoBJ;;AAbA;EACE,WAAA;AAgBF;;AAbA;EACE,0BAAA;AAgBF;;AAdA;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;AAiBF;;AAdA;EACE,cAAA;EACA,6BAAA;EACA,mBAAA;AAiBF;;AAdA;EACE,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAiBF","sourcesContent":["\r\n@import \"../../../variables.scss\";\r\n.parent_card{\r\n    background-color:#f2f2f2; font-size: 12px;\r\n    }\r\n    .agent_feild {\r\n        float: left;\r\n        width: 100%;\r\n      }\r\n      .vendot_type_feild {\r\n        width: 100%;\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n        border-radius: 5px;\r\n        padding-inline: 1%;\r\n        top: -6px;\r\n      }\r\n      .vendor_type {\r\n        width: 100%;\r\n        height: 30px;\r\n        position: relative;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n        height: 0px !important;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n        top: 0;\r\n        height: 0px !important;\r\n        overflow: hidden;\r\n      }\r\n      .text_style{\r\n          font-size: $fontsize;\r\n          color: black;\r\n      }\r\n      .vendor_text{\r\n        color: black;\r\n          display: inline-block;\r\n          top: 7px;\r\n          font-weight: 600;\r\n          font-size: 15px !important;\r\n          text-transform: uppercase;\r\n      }\r\n      .vendor_auto_feild{\r\n        width: 100%;\r\n        position: relative;\r\n        top:0%;\r\n      }\r\n      .text-ellipsis{\r\n        max-width: 93%;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .action_btn{\r\nwidth: 42px;height: 42px;line-height: 32px;background-color: #1590a2;color: white;font-size: 17px;\r\n    }\r\n.vendar_card{\r\n  width: 20%;min-height: 260px;\r\n}\r\n.vendar_card_min{\r\n  width: 33%;min-height: 260px;\r\n}\r\n\r\n.download_files{\r\n  padding-inline: 2%;\r\n    margin-right: 3%;\r\n    border: 1px solid darkgray;\r\n    border-radius: 18px;\r\n    padding-block: 2px;\r\n    font-size: 11px !important;\r\n    i{\r\n      color: #3f9fe3;\r\n    }\r\n}\r\n.download_files:hover{\r\n  background-color: #3f9fe3;\r\n  color: white;\r\n  border: navajowhite;\r\n  i{\r\n    color: white;\r\n  }\r\n}\r\n\r\n.vendor_redirect{\r\n  padding: 2%;\r\n  border-radius: 5%;\r\n  background-color: #ebebeb;\r\n  display: flex;\r\n  align-items: center;\r\n  .redirect_icon{\r\n    font-size: 14px;\r\n    color: grey;\r\n  }\r\n}\r\n.vendor_redirect:first-child{\r\nborder-right: 1px solid #b9b8b8;\r\n}\r\n.vendor_redirect:hover{\r\n  background-color: #1590a2;\r\n  color: white;\r\n  .redirect_icon{\r\n    font-size: 14px;\r\n    color: white;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n.vendor_form_field{\r\n  width: 100%;\r\n\r\n}\r\n.vendor_form_field input{\r\n  font-size: 12px!important;\r\n}\r\n::ng-deep.vendor_form_field .mat-form-field-infix{\r\n  padding: 0%!important;\r\n  padding-bottom: 7px!important;\r\n  padding-top: 2px!important;\r\n}\r\n\r\n::ng-deep.vendor_form_field .mat-form-field-empty.mat-form-field-label {\r\n  display: block;\r\n  position: relative !important;\r\n  top: 7px !important;\r\n}\r\n\r\n::ng-deep.vendor_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n  transform: translateY(-1.59375em) scale(.75);\r\n  width: 133.33333%;\r\n  position: relative;\r\n  top: 13px !important;\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
